import React from 'react';
import { Col, Icon } from 'antd';
import cn from 'classnames';
import FormRow from '../FormRow/FormRow';
import styles from './AddFieldsRow.module.scss';

const AddFieldsRow = ({
  text,
  addFieldsFunc,
  rowType = 'row',
  withBorder = false,
  ...props
}) => {
  return (
    <FormRow {...props} rowType={rowType}>
      <Col
        className={cn(styles.dFlex, {
          [styles.border]: withBorder,
        })}
        span={24}
        onClick={withBorder ? addFieldsFunc : undefined}
      >
        <Icon
          onClick={!withBorder ? addFieldsFunc : undefined}
          className={styles.addIcon}
          type="plus-circle"
        />
        <p
          className={cn(styles.addFieldsText, {
            [styles.addFieldsTextPrimary]: withBorder,
          })}
        >
          {text}
        </p>
      </Col>
    </FormRow>
  );
};

export default AddFieldsRow;
